<template>
    <div id="landingRoot">
        <div class="lpHeaderTop" :class="{ visible: showLpHeaderTop }">
            <div class="topLogo"></div>
            <div class="regButton">
                <button @click="$router.push('#contactFormAnc')" class="button thinButton">
                    Register Now
                </button>
            </div>
        </div>

        <div class="headerContainer">
            <div class="lpHeaderBottom">
                <div class="headerBorder">
                    <img clss="mainTitle" src="../../assets/landing/geminiyacht/geminiLogo.png">
                    <div class="mainTitle">
                        The Gemini Yacht Experience
                    </div>
                    <div class="headerText">
                        Join us for an inclusive, invite-only experience designed for leaders who drive innovation.
                    </div>
                    <img clss="mainTitle" src="../../assets/landing/geminiyacht/bysela.png">
                    <div class="headerBold">
                        April 29 | Hertzelya Marina
                    </div>
                    <div class="regButton dponly">
                        <button id="mainButton" @click="$router.push('#contactFormAnc')" class="button thinButton">
                            Register Now
                        </button>
                    </div>
                </div>
            </div>

        </div>
        <div class="mainContainer">
            <div class="content">
                <strong>Sela and Google Cloud </strong>are pleased to invite you to an exclusive, invite-only gathering
                for tech leaders.
                Set against the stunning backdrop of the Tel Aviv-Jaffa coastline, this event merges high-level AI and
                cloud innovation with a morning of yacht sailing. Connect with industry peers from top-tier tech
                companies, explore the future of the cloud, and enjoy premium refreshments on the water.
            </div>
            <br />
            <div class="mainSubtitle">Seats are limited, apply early.</div>
        </div>
        <div class="agenda">
            <div class="content">
                <div class="agendaTitle">
                    Agenda
                    <br />
                    <img class="robot desktop-only" src="../../assets/landing/geminiyacht/robot.png" />
                </div>
                <div class="agendaText">
                    <strong>08:45 | Gathering & registration</strong>
                    <br />Meet, greet and get ready to embark on the yacht experience.

                    <br /><br /><br /><strong>09:30 | Setting Sail</strong>
                    <br />Leaving the Marina, we'll head out to sea and head to the coasts of Tel Aviv and Jaffa.

                    <br /><br /><br /><strong>10:30 | AI over the waves</strong>
                    <br />Get the latest on Gemini Enterprise, AI and GCP tools from Sela and Google experts, while
                    enjoying
                    beers
                    and snacks .

                    <br /><br /><br /><strong>11:30 | Brunch & Networking</strong>
                    <br />Back on shore, we'll enjoy an exclusive brunch and mingling with fellow leaders from top tech
                    companies.
                </div>
                <img class="robot mobile-only" src="../../assets/landing/geminiyacht/robot.png" />
            </div>
        </div>

        <div id="customLP" class="text landingFormContainer">

            <div class="formContainer">
                <div class="formLeft">
                    <a id="contactFormAnc"></a>
                    <img class="fourdots" src="../../assets/landing/geminiyacht/fourdots.png" />
                    <span class="formText">An invite-only experience designed for leaders ready to push the limits of
                        cloud innovation.</span>
                    <span class="formTitle">Register Now</span>
                </div>
                <div class="formRight">
                    <div>
                        <form class="form land-form-wrap" @submit.prevent="sendForm" v-if="formStatus != 'success'"
                            ref="contactForm" id="contactForm">
                            <input-field class="input land-input aiInputField" label="Full Name" :required="true"
                                v-model="form.fullName" @error-message="onError"
                                :validationType="ValidationTypeEnum.AlphaBet"
                                errorText="First name can only contain letters" />
                            <input-field class="input land-input aiInputField" type="email" label="Work Email"
                                :required="true" v-model="form.email" @error-message="onError"
                                :validationType="ValidationTypeEnum.Email" errorText="Invalid Email address" />
                            <input-field class="input land-input aiInputField" label="Phone Number" :required="true"
                                v-model="form.phone" @error-message="onError" :validationType="ValidationTypeEnum.Phone"
                                errorText="Invalid phone number" />
                            <div class="pairOfFields">
                                <input-field class="input land-input aiInputField" label="Company" :required="true"
                                    v-model="form.company" @error-message="onError"
                                    :validationType="ValidationTypeEnum.Required" errorText="Company is required" />
                                <input-field class="input land-input aiInputField" label="Job Title" :required="true"
                                    v-model="form.jobTitle" @error-message="onError"
                                    :validationType="ValidationTypeEnum.Required"
                                    errorText="Company website is required" />
                            </div>
                            <select class="aiInputField" style="display:none" name="region" id="region"
                                v-model="form.region">
                                <option :value="null" disabled>Geographic Region</option>
                                <option v-for="region in $local.websiteSettings.region" :key="region._id"
                                    :value="region.name">
                                    {{ region.name }}</option>
                            </select>

                            <label class="bgl-checkbox-label">
                                <input @error-message="onError" errorText="You have to agree to the privacy policy"
                                    type="checkbox" class="bgl-checkbox" :required="true" v-model="checkboxChecked" />
                                <span class="checkbox">✔</span>
                                <span class="land-checkbox-txt">
                                    I have read and agree to the <a href="https://selacloud.com/legal/privacy-policy"
                                        target="_blank">Privacy Policy</a></span>
                            </label>
                            <button rect :disabled="formStatus === 'sending' || this.hasFalseProp || !checkboxChecked"
                                type="submit" class="button whiteBorderButton fullWidthButton">
                                Register Now
                            </button>
                            <div class="error" v-if="formStatus == 'fail'">
                                <p>An error occurred while submitting the form</p>
                            </div>
                        </form>
                        <div class="thanks" v-if="formStatus == 'success'">
                            <!-- show a customized thank you text. if it includes @FILE_URL@ then replace it with the URL of the PDF-->
                            <div v-if="lp.formThankyouContent && lp.formThankyouContent != ''"
                                v-html="replaceUrlInThankyouText(lp.formThankyouContent)" />

                            <p v-else> <!-- show a default thank you text-->
                                <span>Thank you for your interest in this event.
                                    As this event is on an invite-only basis, your registration is currently pending
                                    review. <br>Once approved, you will be informed.</span>
                            </p>
                        </div>
                    </div>


                </div>
            </div>
        </div>

        <div class="video-container">
            <video ref="heroVideo" preload="none" autoplay loop muted playsinline>
                <source ref="heroSource" type="video/mp4" />
            </video>
            <img src="../../assets/landing/geminiyacht/yachtMask.png" class="overlay">
        </div>
        <div class="otc-footer">
            <img src="../../assets/landing/google-otc/google-sela-logo.png">
        </div>



    </div>
</template>


<script>
import axios from 'axios';

export default {
    metaInfo() {
        return {
            ssrAppId: "sela",
            ...this.seo({
                title: this.lp.title,
                description: this.lp.blurb,
                image: this.event?.thumbnail?.imageURL || this.lp.cover?.imageURL,
            }),
        };
    },
    components: {

    },
    data: () => ({
        now: new Date(),
        showLpHeaderTop: false,
        lpHeaderShowAt: null, // px; if null we'll compute from .headerContainer
        lpHeaderHideAt: null,
        mainButtonEl: null,
        lastScrollY: 0,
        videoLoaded: false,
        formStatus: "",
        form: {
            pageName: "",
            pageId: "",
            fullName: "",
            email: "",
            company: "",
            phone: "",
            jobTitle: "",
            region: null,
            utmsource: "",
        },
        checkboxChecked: false,
        ValidationTypeEnum: {
            AlphaBet: /^[a-zA-Z ]+$/,
            Email: /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/,
            Phone: /^(\+)?(?:[0-9-()/.\s?]){6,15}[0-9]{1}$/,
            Required: /.+/
        },
        hasFalseProp: false,
        formErrors: {},
    }),

    watch: {

    },
    computed: {
        lp() {
            const id = "gyacht";
            const lp = this.$local.landingPages?.find((c) => c.slug == id);

            return lp
        },
    },
    mounted() {
        console.log("ver 9.4");
        // lazy-load hero video after full page load
        this._onLoad = this.loadHeroVideo.bind(this);
        window.addEventListener('load', this._onLoad);
        // show lpHeaderTop once user scrolls past threshold
        this._onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this._onScroll, { passive: true });
        // compute threshold after DOM paint
        this.$nextTick(() => {
            // locate main button element for visibility-based trigger
            this.mainButtonEl = document.getElementById('mainButton');

            if (!this.mainButtonEl) {
                // fallback to previous height-based threshold
                if (!this.lpHeaderShowAt) {
                    const el = document.querySelector('.headerContainer');
                    if (el) this.lpHeaderShowAt = Math.max(100, el.offsetHeight - 100);
                    else this.lpHeaderShowAt = 300;
                }
            }

            this.onScroll();
        });
    },
    beforeDestroy() {
        if (this._onScroll) {
            window.removeEventListener('scroll', this._onScroll);
            this._onScroll = null;
        }
        if (this._onLoad) {
            window.removeEventListener('load', this._onLoad);
            this._onLoad = null;
        }
    },
    methods: {
        onError(errorObj) {
            this.formErrors[errorObj.label] = errorObj.validation;

            this.setFalseProp();
        },
        async sendForm() {
            try {
                this.setFalseProp();
                if (this.hasFalseProp) {
                    return; // Stop the form submission if there are errors
                }
                this.formStatus = "sending";
                this.form.pageName = this.lp.name;
                this.form.pageId = this.lp._id;

                let utm_source = sessionStorage.getItem('utm_source');
                if (utm_source)
                    this.form.utmsource = utm_source;

                await axios.post(
                    'https://selagroup.com/.netlify/functions/submitLandingDetails',
                    this.form
                );
                this.formStatus = "success";
            } catch (err) {
                console.log(err.response.data);
                this.formStatus = "fail";
            }
        },
        setFalseProp() {
            this.hasFalseProp = Object.values(this.formErrors).includes(false);
        },
        replaceUrlInThankyouText(htmlContent) {
            htmlContent = htmlContent.replace(/@FILE_URL@/g, this.lp.pDFForDownload.imageURL);
            console.log(htmlContent);
            return htmlContent;
        }
        ,
        onScroll() {
            try {
                const y = window.pageYOffset || document.documentElement.scrollTop || 0;

                if (this.mainButtonEl) {
                    const rect = this.mainButtonEl.getBoundingClientRect();
                    const inViewport = rect.top < (window.innerHeight || document.documentElement.clientHeight) && rect.bottom > 0;
                    this.showLpHeaderTop = !inViewport;
                } else {
                    const showAt = this.lpHeaderShowAt || 300;
                    const hideAt = this.lpHeaderHideAt != null ? this.lpHeaderHideAt : Math.max(0, showAt - 150);

                    if (!this.showLpHeaderTop && y >= showAt) this.showLpHeaderTop = true;
                    if (this.showLpHeaderTop && y < hideAt) this.showLpHeaderTop = false;
                }

                this.lastScrollY = y;
            } catch (e) {
                // ignore
            }
        },
        loadHeroVideo() {
            try {
                if (this.videoLoaded) return;
                // resolve the asset via webpack
                const src = require('@/assets/landing/geminiyacht/yachtSailing.mp4');
                if (this.$refs && this.$refs.heroSource && this.$refs.heroVideo) {
                    this.$refs.heroSource.src = src;
                    this.$refs.heroVideo.load();
                    this.$refs.heroVideo.play().catch(() => { });
                    this.videoLoaded = true;
                }
            } catch (e) {
                // ignore
            }
        }
    },
    name: "Landing",
};

</script>

<style scoped>
#landingRoot {
    --contentWidth: 1100px;
    --bgcolor: #181818;
}

#landingRoot {
    color: #ffffff;
    background-color: var(--bgcolor);
}

.headerContainer,
.mainContainer,
.landingFormContainer,
.agenda,
.video-container {
    max-width: 1440px;
    width: 100%;
    margin: auto;
}

.mainSubtitle {
    font-size: 45px;
    font-weight: 400;
    letter-spacing: 0.3px;
    padding-top: 35px;
    color: #2E5CE5;
}

.lpHeaderTop,
.lpHeaderBottom,
.mainContainer {
    width: 100%;
    padding-left: 155px;
    padding-right: 155px;
}


.headerBorder {
    width: 100%;
    border: 1px solid #999999;
    border-radius: 24px;
    
  display: flex;
    flex-direction: column;
    height: 65%;
    justify-content: space-around;
    align-items: center;
    padding-top: 100px;
    padding-bottom: 100px;
    gap: 30px;

}

.headerContainer {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    background-color: var(--bgcolor);
    background-image: url('../../assets/landing/geminiyacht/herobg.jpg');
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: contain;
}


.lpHeaderTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ffffff;
    height: 90px;
}


.lpHeaderBottom {
    display: flex;
    flex-direction: column;
    font-family: "Poppins", serif;
    font-size: 20px;
    font-weight: 300;
    height: 65%;
    justify-content: space-around;
    align-items: center;
    padding-top: 28px;
    padding-bottom: 28px;
    gap: 30px;
}

.mainTitle {
    font-size: 60px;
    font-weight: 300;
    letter-spacing: 1px;
    text-align: center;
}

.headerText {
    font-size: 20px;
    line-height: 31px;
    letter-spacing: 0.3px;
    text-align: center;
}

.headerBold {
    font-size: 30px;
    font-weight: 300;
    letter-spacing: 0;
    color: #3BD3DE;
    text-align: center;
}

.topLogo {
    background-image: url('../../assets/landing/google-otc/google-sela-logo.png');
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: cover;
    width: 264px;
    height: 30px;
}

#landingRoot .button {
    background-color: white;
    color: #2E3033;
    font-family: "Poppins", serif;
    font-size: 16px;
    font-weight: 400;
    padding: 8px;
    min-width: 181px;
    cursor: pointer;
    border: 1px solid #101010;
}

#landingRoot .button:not([rect]) {
    border-radius: 50px;
}


#landingRoot .button:disabled {
    color: grey;
    background-color: #d3d3d3;
    cursor: auto;
}


#landingRoot .button::after {
    content: url('../../assets/landing/google-otc/arrow-right.svg');
    width: 24px;
    height: 24px;
    top: 3px;
    position: relative;
    display: inline-block;
}

#landingRoot .button:disabled::after {
    opacity: 0.6;
}

.mobile-only {
    display: none;
}

.desktop-only {
    display: inline-block;
}


.mainContainer {
    font-family: "Lexend";
    font-size: 22px;
    font-weight: 300;
    color: #000000;
    line-height: 45px;
    letter-spacing: 0.3px;
    line-height: 40px;
    padding-top: 100px;
    padding-bottom: 100px;
    text-align: center;
    background-color: #ffffff;
}

.mainContainer .content {
    max-width: var(--contentWidth);
}

.agenda {
    border-bottom: 1px solid #ffffff;
    padding-bottom: 100px;

    background-image: url('../../assets/landing/geminiyacht/yacht.jpg');
    background-position: top center;
    background-repeat: no-repeat;
    background-size: contain;
    padding-top: 500px;
    background-color: var(--bgcolor);
}

.agenda .content {
    width: 100%;
    display: flex;
    margin: auto;
    max-width: var(--contentWidth);
    position: relative;
}

.agendaTitle {
    font-family: "Lexend";
    font-size: 120px;
    font-weight: 200;
    line-height: 60px;
    letter-spacing: 0.3px;
    flex: 50%;
}

.agendaText {
    flex: 50%;
    font-family: "Poppins", serif;
    font-size: 17px;
    line-height: 24px;
    font-weight: 300;
}

#customLP .formContainer {
    max-width: var (--contentWidth);
    gap: 150px;
    background-color: var(--bgcolor);
}


#customLP .formLeft {
    justify-content: flex-start;
}

.fourdots {
    margin-bottom: 20px;
}

.formText {
    font-size: 22px;
    font-weight: 300;
    letter-spacing: 1.3px;
    line-height: 132%;
    text-align: left;
}


.formTitle {
    font-family: "Lexend";
    font-size: 57px;
    font-weight: 200;
    letter-spacing: 0.3px;
    max-width: 360px;
}

.formSubTitle {
    font-size: 23px;
    font-weight: 300;
    letter-spacing: 1.3px;
    color: var(--light-blue);
}

.new-line {
    font-weight: 200;
    color: var(--light-blue);
}

.video-container {
    position: relative;
    width: 100%;
}

video {
    width: 100%;
    height: auto;
    display: block;
}

.footerbg {
    /* width: 100%; */
    width: 99.8%;
    margin: auto;

    height: auto;
    max-height: 680px;
    display: block;
}

.overlay {
    position: absolute;
    top: -5px;
    left: 0;
    width: 100%;
    pointer-events: none;
}

.overlayText {
    font-family: "Lexend";
    font-size: 75px;
    font-weight: 600;
    color: #ffffff;
    text-shadow: 4px 4px 6px rgba(0, 0, 0, 0.6);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    white-space: nowrap;
}

.otc-footer {
    width: 100%;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.otc-footer img {
    width: 335px;
    height: 42px;
}

.robot {
    padding-top: 40px;
    padding-left: 25px;
}

.lpHeaderTop {
    /* fixed but hidden until shown; doesn't affect layout */
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    opacity: 0;
    transform: translateY(-10px);
    transition: opacity 0.4s ease, transform 0.4s ease;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    height: 70px;
    background: rgba(24, 24, 24, 0.95);
    backdrop-filter: blur(6px);
    z-index: 1200;
    pointer-events: none;
}

.thanks {
    color: white;
}

.lpHeaderTop.visible {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
}

@media screen and (max-width: 1200px) {
    .overlayText {
        white-space: wrap;
        text-align: center;
        font-size: 65px;
    }

    .lpHeaderBottom {
        padding: 28px;
    }
}

@media screen and (max-width: 991px) {

    .headerContainer {
        min-height: 660px;
        height: auto;
    }

    .mainContainer {
        font-size: 16px;
        padding-top: 40px;
        line-height: 28px;
    }

    .agenda {
        padding-top: 30%;
    }

    .agenda .content {
        flex-direction: column;
    }

    .lpHeaderBottom {
        max-width: 100%;
        gap: 40px;
        margin: auto;
    }


    .mainTitle {
        font-size: 35px;
    }


    .mainSubtitle {
        font-size: 31px;
        line-height: 40px;
    }

    .headerText {
        font-size: 20px;
    }

    .headerBold {
        font-size: 30px;
        line-height: 40px;
    }

    .formText {
        font-size: 19px;
    }

    #customLP .formContainer {
        gap: 40px;
    }

    .lpHeaderTop,
    .lpHeaderBottom,
    .mainContainer,
    .agenda,
    #customLP .formRight,
    #customLP .formContainer .formLeft {
        width: 100%;
        padding-left: 35px;
        padding-right: 35px;
    }

    .lpHeaderBottom {
        padding:15px;
    }



    #customLP .formRight {
        margin: 0;
        padding-bottom: 25px;
    }

    .lpHeaderTop {
        width: 100%;
        padding-left: 10px;
        padding-right: 10px;
    }


    #customLP .formRight .pairOfFields {
        flex-direction: column;
    }


    #landingRoot .button {
        font-size: 13px;
        min-width: 130px;
    }

    #customLP .formRight .pairOfFields .input {
        flex: auto;
    }

    .agendaTitle {
        flex: 100%;
        font-size: 80px;
        line-height: 133%;
        padding-top: 50px;
        padding-bottom: 50px;
    }

    .agendaText {
        flex: 100%;
        font-size: 16px;
        line-height: 27px;
    }


    .topLogo {
        background-size: contain;
        width: 165px;
        height: 22px;
    }

    .agendaTitle {
        font-size: 70px;
    }


    .desktop-only {
        display: none;
    }

    .mobile-only {
        display: block;
    }

    .mobileBlock {
        display: block;
    }

    .formTitle {
        font-size: 41px;
        line-height: 80px;
        text-align: left;
    }

    .overlayText {
        font-size: 37px;
        line-height: 42px;
        width: 90%;
    }

    .otc-footer {
        height: 82px;
    }

    .otc-footer img {
        width: 167px;
        height: auto;
    }

    .robot {
        max-width: 202px;
        position: absolute;
        bottom: -212px;
        right: -25px;
    }
}


@media screen and (max-width: 767px) {
    .headerContainer {
        flex-direction: column;
        gap: 20px;
    }
}

/* -------------------------- */

.land-form-thanks {
    max-width: 90%;
    margin: auto;
    background: transparent;
    color: white;
    margin-top: 100px;
}


#requestdemo {
    max-width: 1000px;
    height: 1000px;
    margin: auto;
}


#requestdemo {
    scroll-margin-top: 100px;
}


.video {
    margin-right: 34px;
}

.video-shadow {
    box-shadow: rgb(0, 219, 232) 25px 25px;
    width: 675px;
}


.demo-title {
    display: flex;
    margin: auto;
    margin-top: 20px;
    gap: 20px;
}

.button-container {
    display: flex;
    justify-content: space-between;
}

.button-container input {
    height: 54px;
    margin: 15px;
}

.demo-title img {
    max-width: 120px;
}

.main-container {
    display: flex;
    flex-direction: column;
}







@media screen and (max-width: 479px) {

    .mainContainer {
        /* background-image: url('../../assets/landing/google-otc/mainBgMobile.jpg');
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
        aspect-ratio: 645 / 788; */
    }


    .mobile-title {
        margin: 20px auto;
        border: 10px solid var(--light-blue);
        padding: 14px;
        width: 90;
        text-align: center;
    }

    .mobile-only {
        display: block;
    }

    .desktop-only {
        display: none;
    }

    ::v-deep .btn {
        padding: 12px 22px;
    }
}



/* @media screen and (max-width: 1200px) {
    .agendaTitle {
        font-size: 80px;
    }
} */
</style>